package fr.frux.feature.map.site

import fr.frux.feature.map.MapState
import fr.frux.shared.domain.model.Site
import fr.frux.shared.domain.model.SitePlanting
import fr.frux.shared.domain.model.Tree

/**
 * Lieux a montrer sous les filtres de la carte. La couche des lieux charge l'aire des arbres sans
 * aucun filtre : sans ce tri, une carte filtree (et surtout l'elargissement « Voir les plus
 * proches », au rayon plafond) montrerait tous les lieux du rayon autour des seuls arbres retenus.
 *
 * Un lieu reste s'il repond au filtre par un arbre rattache encore visible, ou par une plantation
 * qui y repond elle-meme. Le masquage des arbres a verifier ne compte pas : il retire des arbres,
 * jamais une plantation.
 */
fun List<Site>.shownUnder(state: MapState): List<Site> {
    val rollupId = state.selectedSpeciesRollupId
    val mapFilter = state.filter.query
    if (rollupId == null && !mapFilter.isActive) return this

    val sitesWithVisibleTree = state.visibleTrees.mapNotNullTo(HashSet()) { it.siteId }
    val speciesById = state.species.associateBy { it.id }

    fun SitePlanting.matches(): Boolean {
        val known = speciesById[species.id]
        return (rollupId == null || state.speciesRollup[species.id] == rollupId) &&
            (mapFilter.form == null || species.form == mapFilter.form) &&
            (mapFilter.part == null || known?.harvests?.any { it.part == mapFilter.part } == true) &&
            (!mapFilter.inSeason || known?.isInSeason(state.currentMonth) == true)
    }

    return filter { site -> site.id in sitesWithVisibleTree || site.plantings.any { it.matches() } }
}

/**
 * Lieux affiches sous le filtre, et epingles a poser : un lieu filtre ne porte plus ses arbres, ceux
 * qui restent visibles reprennent leur epingle (voir [withoutAttachedTo]).
 */
fun MapState.sitesAndPins(
    sites: List<Site>,
    detailZoom: Boolean,
    keepId: Long?,
): Pair<List<Site>, List<Tree>> {
    val shown = sites.shownUnder(this)
    return shown to visibleTrees.withoutAttachedTo(shown.mapTo(HashSet()) { it.id }, detailZoom, keepId)
}
